// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"5b83d93b","335":"cccb1d7b","879":"39eb78fa","969":"12405342"}[chunkId] + ".chunk.js";
};